import { confirmAlert } from "react-confirm-alert";
import "../styles/confirm.css";

/**
 * Custom confirmation dialog with modern styling
 * @param {string} title - Dialog title
 * @param {string} message - Dialog message
 * @param {function} onConfirm - Callback when user confirms
 * @param {function} onCancel - Optional callback when user cancels
 * @param {string} confirmLabel - Label for confirm button (default: "Ya, Hapus")
 * @param {string} cancelLabel - Label for cancel button (default: "Batal")
 */
export const showConfirm = ({
  title = "Konfirmasi",
  message = "Apakah Anda yakin?",
  onConfirm,
  onCancel,
  confirmLabel = "Ya, Hapus",
  cancelLabel = "Batal",
  confirmColor = "red", // 'red' or 'blue'
}) => {
  const colorClasses = {
    red: "bg-red-600 hover:bg-red-700",
    blue: "bg-blue-600 hover:bg-blue-700",
  };

  // Default to red if invalid color
  const btnClass = colorClasses[confirmColor] || colorClasses.red;

  confirmAlert({
    customUI: ({ onClose }) => {
      return (
        <div className="bg-white rounded-2xl shadow-2xl p-6 max-w-md w-full">
          <h2 className="text-2xl font-semibold text-gray-800 mb-3">{title}</h2>
          <p className="text-gray-600 mb-6">{message}</p>
          <div className="flex gap-3 justify-end">
            <button
              onClick={() => {
                if (onCancel) onCancel();
                onClose();
              }}
              className="px-5 py-2.5 rounded-lg border border-gray-300 text-gray-700 hover:bg-gray-50 font-medium transition-colors"
            >
              {cancelLabel}
            </button>
            <button
              onClick={() => {
                if (onConfirm) onConfirm();
                onClose();
              }}
              className={`px-5 py-2.5 rounded-lg text-white font-medium transition-colors ${btnClass}`}
            >
              {confirmLabel}
            </button>
          </div>
        </div>
      );
    },
    overlayClassName:
      "fixed inset-0 bg-black/50 backdrop-blur-sm flex items-center justify-center z-50 overflow-hidden",
    closeOnEscape: false,
    closeOnClickOutside: false,
  });
};

/**
 * Preset for delete confirmation
 * @param {string} itemName - Name of item being deleted
 * @param {function} onConfirm - Callback when user confirms
 */
export const confirmDelete = (itemName, onConfirm) => {
  showConfirm({
    title: "Hapus Data",
    message: `Apakah Anda yakin ingin menghapus ${itemName}? Tindakan ini tidak dapat dibatalkan.`,
    onConfirm,
    confirmLabel: "Ya, Hapus",
    cancelLabel: "Batal",
  });
};

/**
 * Preset for update confirmation
 * @param {string} message - Custom message
 * @param {function} onConfirm - Callback when user confirms
 */
export const confirmUpdate = (message, onConfirm) => {
  showConfirm({
    title: "Konfirmasi Perubahan",
    message: message || "Apakah Anda yakin ingin menyimpan perubahan?",
    onConfirm,
    confirmLabel: "Ya, Simpan",
    cancelLabel: "Batal",
  });
};
